<template>
    <div class="pt-20 bg-workbook-black text-white">

        <div>
            <UContainer class="text-center flex gap-4 md:gap-12 items-center justify-center flex-col md:flex-row">
                <h2 class="text-lg md:text-inherit">
                    Interested in Kudos Sales?
                </h2>
                <UButton to="/contact" aria-label="Open online demo" variant="outline" size="lg"
                    class="font-normal text-white ring-white min-h-11 px-6">
                    Contact us
                </UButton>
            </UContainer>
        </div>
        <UFooter class="mt-6 md:mt-12">

            <template #left>
                <div class="flex w-full items-center justify-center border-none md:border-r border-white">
                    <NuxtLink :to="'/'" aria-label="Go to homepage" class="w-full flex items-center justify-center">
                        <Logo :isDark="false" class="w-full h-auto p-5 lg:p-28 max-w-80 lg:max-w-none" />
                    </NuxtLink>

                </div>

            </template>

            <template #right>
                <UContainer>
                <div class=" w-full px-20 text-center lg:text-left">
                    <p>Kudo Sales is created by: <a aria-label="Visit Hjartat.net"  href="https://hjartat.net" target="_blank"
                            rel="noopener noreferrer">
                            <UIcon class="ml-0 md:ml-3 w-20 h-4 translate-y-1" name="workbook:hjartatwhite" />
                        </a></p>

                    <p>Årehjärtat AB, Årevägen 110, 83752 Åre, Sweden</p>
                    <p><a href="mailto:info@kudosales.com">info@kudosales.com</a> <a class="ml-0 md:ml-8"
                            href="https://hjartat.net" target="_blank" aria-label="Visit Hjartat.net" rel="noopener noreferrer">hjartat.net</a></p>
                </div>
                </UContainer>
            </template>
        </UFooter>
        <UContainer class="text-center flex gap-12 items-center justify-center my-12">
            <p class="text-lg">
                © 2026 Årehjärtat AB. All rights reserved.
            </p>

        </UContainer>
    </div>
</template>